import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoraTipsBulb = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_129_17963)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M11.25 12.9375V14.625C11.25 14.9234 11.1315 15.2095 10.9205 15.4205C10.7095 15.6315 10.4234 15.75 10.125 15.75H7.875C7.57663 15.75 7.29048 15.6315 7.0795 15.4205C6.86853 15.2095 6.75 14.9234 6.75 14.625V12.9375",
				stroke: "currentColor",
				strokeWidth: 1.25,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9 0.5625V1.6875",
				stroke: "currentColor",
				strokeWidth: 1.25,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.125 8.4375H2.25",
				stroke: "currentColor",
				strokeWidth: 1.25,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.8125 2.8125L3.6375 3.60525",
				stroke: "currentColor",
				strokeWidth: 1.25,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.875 8.4375H15.75",
				stroke: "currentColor",
				strokeWidth: 1.25,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.1873 2.8125L14.3623 3.60525",
				stroke: "currentColor",
				strokeWidth: 1.25,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.68665 12.9375H11.3142C12.1498 12.5227 12.8513 11.8802 13.3376 11.084C13.8239 10.2878 14.0754 9.37038 14.0629 8.4375C14.0392 7.10224 13.4982 5.8283 12.5539 4.88398C11.6096 3.93966 10.3357 3.39869 9.0004 3.375C7.66464 3.39871 6.39025 3.9401 5.44586 4.88506C4.50146 5.83002 3.96082 7.10472 3.9379 8.4405C3.926 9.37288 4.1777 10.2897 4.664 11.0853C5.1503 11.8809 5.85143 12.5229 6.68665 12.9375Z",
				stroke: "currentColor",
				strokeWidth: 1.25,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9 15.75V17.4375",
				stroke: "currentColor",
				strokeWidth: 1.25,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9 10.125V12.9375",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.3125 8.4375L9 10.125L10.6875 8.4375",
				stroke: "currentColor",
				strokeWidth: 1.25,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_129_17963",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 18,
			fill: "white"
		})
	}) })]
});
export default SvgNoraTipsBulb;
